import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    DefaultDataServiceConfig,
    EntitySelectorsFactory,
    HttpUrlGenerator
} from '@ngrx/data';
import { createSelector, Store } from '@ngrx/store';
import moment from 'moment';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDataService } from '../efaact.data-service';
import { LoginModel } from './login.model';

export const entityName = 'User';
@Injectable({ providedIn: 'root' })
export class ManageUsersDataService extends EfaactDataService<LoginModel> {
    mapItems(item: LoginModel): LoginModel {
        return {
            ...item,
            CCAccountListID: (item.CCAccountListID as string)?.split(','),
            id: item.EmployeeListID as string,
            LockDate: item.LockDate
                ? moment(item.LockDate).isValid()
                    ? moment(item.LockDate).toDate()
                    : undefined
                : undefined
        };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}

export const selectors = new EntitySelectorsFactory().create<LoginModel>(
    entityName
);

export const getActiveUsers = createSelector(selectors.selectEntities, users =>
    users.filter(user => user.IsActive === true)
);
